/**
 * Bildirim / paylaşım bağlantıları.
 * - `/go?s=<ScreenId>&o=<ObjectId>&kf=<KeyField>&kv=<KeyValue>`: ekranı (yoksa nesnenin
 *   ekranını) o kayda süzülmüş açar. Yetki: ekran kullanıcının menüsünde olmalı.
 * - `/s/<ScreenId>?f=<durum>`: paylaşılan ızgara durumu (bkz. grid/model/shareState).
 */
export interface GoLink {
  screenId: string | null;
  objectId: string | null;
  keyField: string | null;
  keyValue: string | null;
}

const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const IDENT = /^[A-Za-z_][A-Za-z0-9_]{0,127}$/;

export function parseGoLink(search: string): GoLink {
  const p = new URLSearchParams(search);
  const s = p.get('s');
  const o = p.get('o');
  return {
    screenId: s && GUID.test(s) ? s : null,
    objectId: o && GUID.test(o) ? o : null,
    keyField: p.get('kf'),
    keyValue: p.get('kv'),
  };
}

/**
 * Kayıt süzgeci: `[Alan] = N'değer'`. Alan adı yalnız tanımlayıcı olabilir, değer tırnak
 * kaçışlıdır — bağlantı SQL taşıyamaz. Geçersizse null (ekran süzgeçsiz açılır).
 */
export function keyWhere(keyField: string | null, keyValue: string | null): string | null {
  if (!keyField || keyValue == null || !IDENT.test(keyField)) return null;
  return `[${keyField}] = N'${keyValue.replace(/'/g, "''")}'`;
}
